__webpack_require__.p = "/algovision/";